<template lang="pug">
  div
    Row
      Col(:lg="24" :md="24")
        Card.dashBoardCard
          LineChartWrapper(
            :chartType="'cacheStatusLineChart'"
            :chartTitle="''"
            :chartDataSetLabel="[$t('dashboard.dataCachedUsage'), $t('dashboard.dataServedUsage')]"
            :numeralFormat="'0b'"
            :withCard="false"
            :chartHeight="320"
            :linePointRadius="[4, 4]"
            :linePointHoverRadius="[8, 8]"
            :linePointBackgroundColor="['white', 'white']"
            :linePointBorderWidth="[3, 3]"
            :lineBorderColors="[colorScheme.green.border, colorScheme.blue.border]"
            :lineBackgroundGradientStops="[colorScheme.green.gradientStops, colorScheme.blue.gradientStops]"
            :linePointHoverBorderWidth="[5, 5]"
            :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)', 'rgba(152, 202, 235, 0.5)']"
            :linePointHoverBackgroundColor="['white', 'white']" 
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
          SingleNumWrapper(
            :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
            :chartType="'servedsumnum'"
            :chartTitle="$t('dashboard.dataServedUsage')"
            :numeralFormat="'0.00b'"
            :withCard="false"
            :textInSingleLine="true"
            maxFontSize="26px"
            style="text-align: right;"
          )
          SingleNumWrapper(
            :class="showRawBtnStyle == 'iconBtn' ? 'underLineChartWrapper' : ''"
            :chartType="'servedByteRateNum'"
            :chartTitle="$t('dashboard.avgServedSpeedRate')"
            :numeralFormat="'0.00b'"
            :numStringSuffix="' / s'"
            :withCard="false"
            :textInSingleLine="true"
            maxFontSize="26px"
            style="text-align: right;"
          )
    Row
      Col(:lg="8" :md="12")
        Card.dashBoardCard
          PieChartWrapper(
              :chartType="'sourceIpPieChartByBytesSent'"
              :chartTitle="$t('dashboard.visitorIp')"
              :numeralFormat="'0.00b'"
              :topNSize="5"
              :chartHeight="chartHeight"
              :withCard="false"
              :pieBackgroundColors="[colorScheme.colorSets.fill]"
              :legendPosition="'right'"
              :legendAlign="'start'"
              :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
              )

      Col(:lg="16" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
            :chartType="'servicegroupbarchartByBytesSent'"
            :chartTitle="''"
            :chartDataSetLabel="[$t('dashboard.serviceGroupNameText')]"
            :numeralFormat="'0.00b'"
            :topNSize="3"
            :chartHeight="chartHeight"
            :withCard="false"
            :direction="direction"
            :barBorderColors="[colorScheme.blue.border]"
            :barBackgroundColors="[colorScheme.blue.fill]"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
    Row
      Col(:lg="8" :md="12")
        Card.dashBoardCard
          PieChartWrapper(
            :chartType="'countryPieChartByBytesSent'"
            :chartTitle="$t('dashboard.countryText')"
            :numeralFormat="'0.00b'"
            :topNSize="5"
            :chartHeight="chartHeight"
            :withCard="false"
            :pieBackgroundColors="[colorScheme.colorSets.fill]"
            :legendPosition="'right'"
            :legendAlign="'start'"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
      Col(:lg="16" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
            :chartType="'domainBarChartBytesSent'"
            :chartDataSetLabel="[$t('dashboard.domainNameText')]"
            :numeralFormat="'0.00b'"
            :topNSize="10"
            :chartHeight="chartHeight"
            :withCard="false"
            :direction="direction"
            :barBorderColors="[colorScheme.blue.border]"
            :barBackgroundColors="[colorScheme.blue.fill]"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
    Row
      Col(:lg="8" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
            :chartType="'sourceIpBarChartByBytesSent'"
            :chartDataSetLabel="[$t('dashboard.visitorIp')]"
            :numeralFormat="'0.00b'"
            :topNSize="10"
            :chartHeight="chartHeight"
            :withCard="false"
            :direction="direction"
            :barBorderColors="[colorScheme.blue.border]"
            :barBackgroundColors="[colorScheme.blue.fill]"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
      Col(:lg="16" :md="12")
        Card.dashBoardCard
          BarChartWrapper(
            :chartType="'uriBarChartByBytesSent'"
            :chartDataSetLabel="[$t('dashboard.uri')]"
            :numeralFormat="'0.00b'"
            :topNSize="10"
            :chartHeight="chartHeight"
            :withCard="false"
            :direction="direction"
            :barBorderColors="[colorScheme.blue.border]"
            :barBackgroundColors="[colorScheme.blue.fill]"
            :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
            )
    Row
      Col(:lg="24" :md="24")
        Card.dashBoardCard
            BarChartWrapper(
                :chartType="'userAgentBarChartByBytesSent'"
                :chartDataSetLabel="[$t('dashboard.userAgent')]"
                :numeralFormat="'0.00b'"
                :topNSize="10"
                :chartHeight="chartHeight"
                :withCard="false"
                :direction="direction"
                :barBorderColors="[colorScheme.blue.border]"
                :barBackgroundColors="[colorScheme.blue.fill]"
                :isPointStyle="$store.getters.getChartConfig.legendPointStyle"
                ) 
</template>
<script>
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import BarChartWrapper from "@/components/dashboard/BarChartWrapper";
import SingleNumWrapper from "@/components/dashboard/SingleNumWrapper";
import PieChartWrapper from "@/components/dashboard/PieChartWrapper";

import colorScheme from "@/data/colorScheme";

export default {
    components: {
        LineChartWrapper,
        BarChartWrapper,
        SingleNumWrapper,
        PieChartWrapper
    },
    props: {
        groupNames: {
            type: Array,
            default: () => []
        },
        serviceGroupNames: {
            type: Array,
            default: () => []
        },
        domains: {
            type: Array,
            default: () => []
        },
        origins: {
            type: Array,
            default: () => []
        },
        edgeNames: {
            type: Array,
            default: () => []
        },
        dateRange: {
            type: String,
            default: "1"
        },
        customTimeRange: {
            type: Array,
            default: () => ["", ""]
        },
        direction: {
            type: String,
            default: "vertical"
        }
    },
    data() {
        return {
            colorScheme: colorScheme,
            chartHeight: 280
        };
    },
    watch: {
        dateRange: function(value) {
            console.log(value);
        }
    },
    computed: {
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        }
    }
};
</script>
<style lang="less" scoped>
.dashBoardCard {
    margin: 6px;
    min-height: 450px;
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage/DataUsageContent.vue